import { InjectionToken } from '@angular/core';
import { AsyncResult } from '@common/result/asyncResult';
import { PlatformUser } from '@/app/platform/platform-core/user/models/platform-user';
import { UserEgiApp } from '@/app/platform/platform-core/user/models/user-egi-app';
import { Observable } from 'rxjs';
import { Credentials } from '@/app/platform/platform-shared/models/credentials';

export const AUTHENTICATION_SERVICE = new InjectionToken<AuthenticationService>('');

export interface AuthenticationService {
  validateCredentials(credentials: Credentials): AsyncResult<IdentityValidation>;

  authenticate(authenticationToken: string): AsyncResult<ValidAuthenticationResponse>;

  logout(): AsyncResult<boolean>;

  loadSavedAuthentication(): AsyncResult<ValidAuthenticationResponse>;
}

export const AUTHENTICATION_REFRESHER = new InjectionToken<AuthenticationRefresher>('');

export interface AuthenticationRefresher {
  refresh(): AsyncResult<ValidAuthentication>;
}

export type IdentityValidation = [user: PlatformUser, authenticationOnlyToken: string];

export interface ValidAuthenticationResponse {
  authentication: ValidAuthentication;
  refresher$: Observable<ValidAuthentication>;
}

export interface ValidAuthentication {
  apps: UserEgiApp[];
  jwtToken: string;
  user: PlatformUser;
}
